// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"df7f770d","724":"df7f770d"}[chunkId] + ".chunk.css";
};